import React, { useEffect, useState } from 'react';
import logo from '../../Assets/img/logo-small.png';
import Api from '../../component/Api';
import { useNavigate } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Newpassword = () => {

    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [conpassword, setConPassword] = useState('');
    const [error, setloginerror] = useState(false);
    const [isSubmitButtonEnabled, setIsSubmitButtonEnabled] = useState(false);
    const [isRedirecting, setIsRedirecting] = useState(true);
    const navigate = useNavigate();
    const [validation, setvalidation] = useState(true);
    const [errormsg,setErrormsg] = useState('');
    const [getToken, setToken] = useState(false);
    const [msgError, setMsgerror] = useState(false);


    const { http } = Api();

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    
   useEffect(() => {
    localStorage.removeItem('validationerror');

    const url = window.location.href;
    let token = ''

    const urlParts = url.split('?');
    if (urlParts.length > 1) {
         token = (urlParts[1]);
    }
    
    setToken(token);
    
   
    // console.log(token);

    if (token) {
        http.post('/validateToken', {
            "token": token
        })
            .then(res => {
                // console.log(res);
                setIsRedirecting(false);
            })
            .catch(error => {
                // console.log(error);
                setErrormsg(error.response.data.message)
                setvalidation(false);
                setIsRedirecting(false);
            });
    } else {
       
        setIsRedirecting(false);
        setvalidation(false);
        setErrormsg('Somthing went wrong')
        setTimeout(() => {
            navigate("/");
          }, 1000);
    }
    setIsRedirecting(false);
}, []);


    useEffect(() => {

        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!])(?=\S+$).{8,}$/;
        let errorMessage = '';

        if (password === '' && conpassword === '') {
            setIsSubmitButtonEnabled(false);
            setloginerror('');
        } 
      
        if (password.length > 3){
            if (!/[a-z]/.test(password)) {
                errorMessage = 'Password must contain at least one lowercase letter.';
                setMsgerror(errorMessage);

            }else if (!/[A-Z]/.test(password)) {
                errorMessage = 'Password must contain at least one uppercase letter.';
                setMsgerror(errorMessage);

            } else if (!/\d/.test(password)) {
                errorMessage = 'Password must contain at least one digit.';
                setMsgerror(errorMessage);

            } else if (!/[@#$%^&+=!]/.test(password)) {
                errorMessage = 'Password must contain at least one special character.';
                setMsgerror(errorMessage);

            }else if (password.length < 8) {
                errorMessage = 'Password must be at least 8 characters long.';
                setMsgerror(errorMessage);
            }
            else {
                setMsgerror(false);
            } 
            
            if (password === conpassword && passwordRegex.test(password)){

        
                setIsSubmitButtonEnabled(true);
                setloginerror('');
                setMsgerror(false);

                return;
            }

            setIsSubmitButtonEnabled(false);
        }
        setloginerror(errorMessage);
    }, [password, conpassword]);
  


    const handleSubmit = (e) => {
       
        e.preventDefault(); 
      
            setIsRedirecting(true); // Set redirecting to true before making the API call
      
            http.post('/updatePassword', {
                token: getToken,
                password: password,
                password_confirmation: conpassword
            })
              .then(response => {
            //    console.log(response);
                if (response.data.status_code === "MSG13") {
                  
                   
                    toast.success("Password Updated Successfully");
                    setTimeout(() => {
                        navigate("/");
                      }, 3000);
                }
                else{
                   
                    toast.error(response.data.message); 
                    setTimeout(() => {
                        navigate("/");
                      }, 2000);
                }
              })
              .catch(error => {
                toast.error("Somthing Went wrong");
                // console.log(error);
                setTimeout(() => {
                    navigate("/");
                  }, 1000);
              
              })
              .finally(() => {
                setIsRedirecting(false); // Set redirecting back to false after the API call completes
              });
          
    };





    const handle = () => {

        navigate('/');

    }


    return (

        <>
        <ToastContainer />
            {isRedirecting ? (
                <div className='body23'>
                    <div className="container23">
                        <div className="login-box23" style={{ minHeight: "50%", alignContent: "center" }}>
                            <div className="card-body d-flex justify-content-center align-items-center" >
                                <div className="containeranimate">
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div className='body23'>
                        <div className="container23">
                            <div className="login-box23">

                                <div className="circle23">
                                    <img className="img-fluid for-light" src={logo} alt="MGU Logo" />
                                </div>
                                {validation ? (
                                    <>
                                        <div className='heading12'>Create a New Password</div>
                                        <form onSubmit={handleSubmit} className="form12">
                                            <div className="password-wrapper">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className={`input-field23 ${error ? 'error12' : ''}`}
                                                    placeholder="Password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <span
                                                    className="password-toggle e-icon"
                                                    onClick={toggleShowPassword}
                                                >
                                                    <i className={`fa ${showPassword ? "fa-eye fa-stl" : "fa-eye-slash fa-stl"}`} />
                                                </span>
                                            </div>
                                            <div className="password-wrapper">
                                                <input
                                                    type="password"
                                                    className={`input-field23 ${error ? 'error12' : ''}`}
                                                    placeholder="Confirm Password"
                                                    value={conpassword}
                                                    onChange={(e) => setConPassword(e.target.value)}
                                                />
                                                <span
                                                className="password-toggle e-icon"
                                               
                                            >
                                               <i className={`bi ${isSubmitButtonEnabled ? "bi-check-circle-fill text-success" : "bi-x-circle-fill text-danger"}`} />

                                            </span>

                                            </div>
                                            {msgError && <p className="text-danger">{msgError}</p>}
                                            <button
                                                type="submit"
                                                className="submit-btn23"
                                                style={{ width: '50%' }}
                                                disabled={!isSubmitButtonEnabled}
                                                onclick={handleSubmit}
                                            >
                                                Submit
                                            </button>
                                        </form>
                                    </>
                                ) : (
                                    <>
                                        <div className="alert alert-danger" role="alert">
                                            <p style={{ textAlign: 'center', textJustify: 'auto' }}>{errormsg}</p>
                                        </div>

                                        <button
                                            type="submit"
                                            className="submit-btn23"
                                            style={{ width: '50%' }}
                                            onClick={handle}
                                        >
                                            Go Back
                                        </button>
                                    </>




                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Newpassword;